const state = {
  config: {},
};

const mutations = {
  SET_CONFIG(state, value) {
    state.config = value;
  },
};

const actions = {};

export default {
  state,
  mutations,
  actions,
};
